
<template>
  <div>
    <div class="home" style="left:unset;right:20px">
      <img width="24" @click="loginOut" class="lt" src="../../../assets/images/tc.png" />
    </div>
    <div :class="isHome?'h-c':'h-c h-cc'" id="rightScroll">
      <div :class="isHome?'firstDiv':''">热门城市</div>
      <div @click="scorllFunL" :class="isHome?'twoDiv':''">
        <img width="7" src="../../../assets/images/zuo1.png" />
      </div>
      <div
        v-for="(i,k) in cityData"
        :class="k==isIndex?'c':''"
        :id="i.cityCode==isSelectCode?'c':''"
        :key="k"
        @click="getDetails(i,k)"
      >{{i.cityName}}</div>
      <div @click="scorllFun">
        <img width="7" v-if="cityData.length>15" src="../../../assets/images/you1.png" />
        <img width="7" v-else src="../../../assets/images/you.png" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from '@/api/road.js'
export default {
  data() {
    return {
      cityData: [],
      isIndex: -1
    }
  },
  props: {
    isHome: Boolean,
    isSelectCode: String
  },
  watch: {},
  created() {
    clearInterval(this.switchTime)
    clearInterval(this.switchTimel)
    this.getTop20City()
  },
  methods: {
    scorllFun() {
      var _this = this
      var t = document.querySelector('#rightScroll').scrollLeft
      _this.switchTime = setInterval(function() {
        t = t + 50
        if (t > 900) {
          clearInterval(_this.switchTime)
        }
        setTimeout(function() {
          clearInterval(_this.switchTime)
        }, 1000)
        document.querySelector('#rightScroll').scrollLeft = t
      }, 30)
    },
    scorllFunL() {
      var _this = this
      var t = document.querySelector('#rightScroll').scrollLeft
      _this.switchTimel = setInterval(function() {
        t = t - 20
        if (t < 0) {
          clearInterval(_this.switchTimel)
          document.querySelector('#rightScroll').scrollLeft = 0
        }
        setTimeout(function() {
          clearInterval(_this.switchTimel)
          document.querySelector('#rightScroll').scrollLeft = 0
        }, 1000)
        document.querySelector('#rightScroll').scrollLeft = t
      }, 1)
    },
    getDetails(e, k) {
      this.isIndex = k
      if (this.isHome) {
        this.$router.push({
          path: '/roadOperation/hotCities',
          query: {
            id: 0,
            cityName: e.cityName,
            cityCode: e.cityCode,
            isHotCity: true
          }
        })
      } else {
        this.$emit('returnCityData', e)
      }
    },
    // 退出
    loginOut() {
      var _this = this
      this.$confirm('是否确定退出？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          _this.logouthandle()
        })
        .catch(action => {})
    },
    async logouthandle() {
      await this.$store.dispatch('logout')
      this.clearCookie()
      window.location.reload()
    },
    lockhandle() {
      this.$store.dispatch('setLockState', 'lock')
      this.$router.push({
        path: '/lock'
      })
      this.$message.success(this.$t('lock.locked'))
    },
    clearCookie() {
      var date = new Date()
      date.setTime(date.getTime() - 10000)
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie = keys[i] + '=0;expires=' + date.toGMTString()
        }
        // document.cookie=keys[i]+"=0; expire="+date.toGMTString()+"; path=/";
      }
    },
    // 获取热门城市
    getTop20City() {
      axios.getTop20City().then(e => {
        if (e.data) {
          this.cityData = e.data
        }
      })
    }
  }
}
</script>
<style>
.h-c {
  position: absolute;
  width: 92%;
  left: 1%;
  top: 15px;
  height: 60px;
  background: rgba(25, 29, 50, 0.6);
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 100;
  border: 1px solid #323856;
  color: #ffffff;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  font-size: 14px;
}
.home {
  width: 55px;
  height: 57px;
  background: #444a67;
  border-radius: 2px;
  position: absolute;
  left: 15px;
  line-height: 70px;
  text-align: center;
  z-index: 100;
  top: 15px;
}

.home .lt {
  margin-left: 4px;
}
.h-c::-webkit-scrollbar {
  display: none;
}

.h-cc {
  width: 88%;
  /* height: 60px; */
  left: 5%;
}
.h-c > div {
  display: inline-block;
  padding: 22px 0;
  padding-right: 40px;
}
.h-c > div:nth-child(3) {
  padding-left: 130px;
}
.h-c > div:hover {
  cursor: pointer;
  color: #00a0ff;
}
.h-c > div.c,
.h-c > div#c {
  color: #00a0ff;
}
.h-c > div:first-child {
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  width: 100px;
  line-height: 30px;
  margin-right: 5px;
  height: 100%;
  text-align: center;
  position: fixed;
  padding-right: 0px;
  z-index: 100;
  top: 16px;
  padding-top: 13px;
  background: rgba(25, 29, 50, 0.6);
  left: 4.5%;
  height: 56px;
}

.h-c > div:nth-child(2),
.h-c > div:last-child {
  background: #444a67;
  border-radius: 2px;
  padding: 0;
  padding-top: 0px;
  text-align: center;
  position: fixed;
  top: 18px;
  z-index: 100;
  left: 155px;
  width: 22px;
  height: 56px;
}
.h-c > div:nth-child(2) img,.h-c > div:last-child img{
  margin-top: 23px;
}
.h-c > div.twoDiv:nth-child(2) {
  left: 105px;
}
.h-c > div.firstDiv:first-child {
  left: 10px;
  padding-top: 13px;
}
.h-c > div:last-child {
  left: unset;
  right: 7.5%;
}
.h-c > div:first-child:hover{
  color: #ffffff
}
</style>